exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-text[data-v-3214bca8]{color:#fff}", ""]);

// exports
